export enum NotificationPermission {
  GRANTED = "granted",
  DENIED = "denied",
  UNDETERMINED = "undetermined",
}

export interface Preferences {
  acknowledgedNotificationBadgeState: NotificationPermission;
  acknowledgedEmailChangeExpired: boolean;
  jobSearches: JobSearch[];
}

export interface CurrentUser {
  firstName: string;
  lastName: string;
  memberNumber?: string;
  oneLoginId?: string;
  token?: string;
  refreshToken?: string;
  expiresAt?: number;
}

export interface ContextValue extends CurrentUser, Preferences {
  setAcknowledgedNotificationBadgeState(state: NotificationPermission): void;
  setAcknowledgedEmailChangeExpired(state: boolean): void;
  addJobSearch(search: JobSearch): void;
  clearJobSearches(): void;
  setCurrentUser(user: CurrentUser): void;
  logout(): void;
  loaded: boolean;
}

export type JobSection = { type: "section"; name: string };
export type JobPlace = { type: "place"; name: string; miles: number; lat: number; lng: number };
export type JobLocation = JobSection | JobPlace;

export interface JobSearch {
  text?: string;
  location?: JobLocation;
}
